module.exports = __webpack_public_path__ + "img/business-doc-image.1e1e6720.svg";